import PropTypes from 'prop-types'
import { federalStatePropType } from './federal-state-prop-type'

/**
 * PropType defining a country
 *
 * @property {string}                  [countryCode]   - The phone country code
 * @property {[federalStatePropType]}  [federalStates] - An array of federal states that partition this country.
 * @property {string}                  isoCode         - The ISO-3166-1 alpha-2 code of the country.
 * @property {string}                  stringCode      - The stringCode to translate the country name
 */
export const countryPropType = PropTypes.shape({
    countryCode: PropTypes.string,
    federalStates: PropTypes.arrayOf(federalStatePropType),
    isoCode: PropTypes.string.isRequired,
    stringCode: PropTypes.string.isRequired
})
